import {
  MOBILE_NUMBER_REGEX,
  NAME_REGEX,
  PINCODE_REGEX,
} from '@zet/utils/regularExpression'
import {
  MOBILE_NUMBER_VALIDATION,
  NAME_FIELD_EMPTY,
  NAME_FIELD_VALIDATION,
} from '@zet/utils/validationMessage'
import { z } from 'zod'

export const customerInfoValidationSchema = z.object({
  fullName: z
    .string()
    .min(1, { message: NAME_FIELD_EMPTY })
    .regex(new RegExp(NAME_REGEX), NAME_FIELD_VALIDATION)
    .trim(),
  phoneNumber: z
    .string()
    .min(1, { message: MOBILE_NUMBER_VALIDATION })
    .regex(new RegExp(MOBILE_NUMBER_REGEX), MOBILE_NUMBER_VALIDATION)
    .max(10, { message: MOBILE_NUMBER_VALIDATION }),
  email: z.string().email({ message: 'Invalid email' }),
})

export const customerBasicDetailsValidationSchema = z.object({
  pincode: z
    .string()
    .min(1, { message: 'Field is required!' })
    .length(6, { message: 'Not a valid PIN code' })
    .regex(PINCODE_REGEX, 'Invalid Pin Code'),
  employmentType: z.string().min(1, { message: 'Please select a type' }),
  annualIncome: z
    .string()
    .min(1, { message: 'Income is required' })
    .regex(/^[\d,]+(\.\d{1,2})?$/, { message: 'Please enter valid income' }),
  modeOfIncome: z.string().min(1, { message: 'Please select a type' }),
})

export const panDetailsValidationScheme = z
  .object({
    panNumber: z
      .string()
      .min(1, { message: 'Field is required!' })
      .max(10)
      .regex(
        new RegExp(/(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/),
        'Invalid PAN'
      ),
    dob: z.string({ required_error: 'Please select DOB' }),
  })
  .required()
